import _definePage_default_0 from 'C:/semics/ava/ava-front-web/src/pages/app.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('C:/semics/ava/ava-front-web/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('C:/semics/ava/ava-front-web/src/pages/[...all].vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/app',
    name: '/app',
    component: () => import('C:/semics/ava/ava-front-web/src/pages/app.vue'),
    children: [
      {
        path: '',
        name: '/app/',
        component: () => import('C:/semics/ava/ava-front-web/src/pages/app/index.vue'),
        /* no children */
      },
      {
        path: 'device',
        /* internal name: '/app/device' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/app/device/[id]',
            component: () => import('C:/semics/ava/ava-front-web/src/pages/app/device/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _definePage_default_0
  ),
  {
    path: '/auth',
    name: '/auth',
    component: () => import('C:/semics/ava/ava-front-web/src/pages/auth.vue'),
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('C:/semics/ava/ava-front-web/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'signup',
        name: '/auth/signup',
        component: () => import('C:/semics/ava/ava-front-web/src/pages/auth/signup.vue'),
        /* no children */
      },
      {
        path: 'verify',
        name: '/auth/verify',
        component: () => import('C:/semics/ava/ava-front-web/src/pages/auth/verify.vue'),
        /* no children */
      }
    ],
  }
]
